import { Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpUrlEncodingCodec } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { isNullOrEmpty } from '@awp/core/utils';
import { RESPONSE_LOGGER_TOKEN } from '../response-console.logger';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export var ROUTE_PARAM_REGEX = /(?:\{)([a-zA-Z0-9]+)(?:[\?]?)(?:[\}])/g;
var SirenHttp = /** @class */ (function () {
    function SirenHttp(httpClient, injector) {
        this.httpClient = httpClient;
        this.injector = injector;
        this._headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        this._encoder = new HttpUrlEncodingCodec();
    }
    SirenHttp.prototype.get = function (link, param) {
        if (link == null) {
            throw new Error('Link is not defined');
        }
        var url = (typeof link === 'string') ? link : link.href;
        var loggers = (this.injector.get(RESPONSE_LOGGER_TOKEN) || []);
        var parsedUrl = this.parseUrlRouteParams(url, param ? param.route : null);
        return this.httpClient.get(parsedUrl, { headers: this._headers })
            .pipe(tap(function (response) {
            loggers.forEach(function (logger) {
                logger.log(parsedUrl, response);
            });
        }));
    };
    SirenHttp.prototype.getBlob = function (link, param) {
        if (link == null) {
            throw new Error('Link is not defined');
        }
        var url = (typeof link === 'string') ? link : link.href;
        var parsedUrl = this.parseUrlRouteParams(url, param ? param.route : null);
        return this.httpClient.get(parsedUrl, { headers: this._headers, responseType: 'blob' });
    };
    SirenHttp.prototype.post = function (action, request, param) {
        var url;
        var method = 'POST';
        if (action == null) {
            throw new Error('Action is not defined');
        }
        if (typeof action === 'string') {
            url = action;
        }
        else {
            url = action.href;
            method = action.method != null ? action.method : method;
        }
        var loggers = (this.injector.get(RESPONSE_LOGGER_TOKEN) || []);
        var parsedUrl = this.parseUrlRouteParams(url, param ? param.route : null);
        return this.httpClient.request(method, parsedUrl, {
            body: request,
            params: param != null ? param.queryParams : null,
            headers: this._headers
        })
            .pipe(tap(function (response) {
            loggers.forEach(function (logger) {
                logger.log(parsedUrl, response);
            });
        }));
    };
    SirenHttp.prototype.parseUrlRouteParams = function (url, params) {
        var _this = this;
        if (params == null)
            return url;
        var result = url.replace(ROUTE_PARAM_REGEX, function (match, key) {
            var value = params[key];
            var encodedValue = isNullOrEmpty(value) ? value : _this._encoder.encodeValue(value);
            return encodedValue;
        });
        return result;
    };
    SirenHttp.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SirenHttp_Factory() { return new SirenHttp(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i0.INJECTOR)); }, token: SirenHttp, providedIn: "root" });
    return SirenHttp;
}());
export { SirenHttp };
